module.exports = __webpack_public_path__ + "media/customizations/avemariamaster/back-600485534de57f67cecff0c09aa9eb9a.jpg";